import { FunctionComponent } from 'react';
import MainHeading from '../../../../components/shared/MainHeading';
import PieRecordChart from './PRC';

interface AnaliysisPieChartViewProps {
    text: string;
    data: Array<BarData>;
}

interface BarData {
    country: string;
    visits: number;
}

const AnaliysisPieChartView: FunctionComponent<AnaliysisPieChartViewProps> = ({
    data,
    text,
}: AnaliysisPieChartViewProps) => (
    <div className="col-xs-12 mt-40">
        <MainHeading text={text} />
        <PieRecordChart id={text} chart={data} />
    </div>
);
export default AnaliysisPieChartView;
